import { useMemo, useState } from 'react';
import { ResponseError } from 'services/api/base';
import { useListWarningsQuery } from 'services/api/home';
import { useHandleRequestErrors } from 'utils/hooks';

export const LAST_SEEN_KEY = 'lastSeenTimestamp';

export default function useListHomeWarnings() {
  const { data, error, refetch } = useListWarningsQuery();
  const warnings = data || [];
  const timestamps = warnings.map((warning) => warning.timestamp);
  const latestTimestamp = Math.max(...timestamps);
  const [lastSeen, setLastSeen] = useState<string | null>(
    localStorage.getItem(LAST_SEEN_KEY),
  );
  const showNotification = useMemo(() => (
    lastSeen === null || Number(lastSeen) < latestTimestamp
  ), [lastSeen, latestTimestamp]);

  const updateLastSeen = () => {
    localStorage.setItem(LAST_SEEN_KEY, latestTimestamp.toString());
    setLastSeen(latestTimestamp.toString());
  };

  useHandleRequestErrors(error as ResponseError | undefined);

  return {
    warnings,
    refetch,
    showNotification,
    updateLastSeen,
  };
}
